import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertOctagon, TrendingDown, ShieldCheck } from "lucide-react";
import { formatNumber, dec } from "@/lib/formatters";

const mill = (v) => (v == null ? "—" : `${formatNumber(Math.round(v / 1000))} mill. kr`);

const TONE = {
  hog: { border: "border-[#E3B4AE]", bg: "bg-[#FDF3F1]", text: "text-[#C0392B]", badge: "Kraftig fall" },
  moderat: { border: "border-[#EFD9B4]", bg: "bg-[#FDF8EF]", text: "text-[#B4791F]", badge: "Markert fall" },
};

export const VarselSection = ({ data, kommuneName }) => {
  if (!data || data.first_year == null) return null;
  const alerts = data.alerts || [];
  return (
    <Card className="bg-white border border-[#E6E9F0] rounded-lg mb-8" data-testid="varsel-card">
      <CardHeader className="border-b border-[#E6E9F0] pb-4">
        <CardTitle className="text-lg font-medium text-[#1F2A36] flex items-center gap-2">
          <AlertOctagon className="w-5 h-5 text-[#C0392B]" />
          Historiske varsel
        </CardTitle>
        <p className="text-sm text-[#4B647F]">
          År der fonda eller arbeidskapitalen fall kraftig i {kommuneName}, {data.first_year}–{data.last_year}.
        </p>
      </CardHeader>
      <CardContent className="pt-6 space-y-3">
        {alerts.length === 0 ? (
          <div className="flex items-start gap-3 p-4 border border-[#CFE3D8] bg-[#F3FAF6] rounded-lg" data-testid="varsel-ingen">
            <ShieldCheck className="w-5 h-5 text-[#2F7D5B] mt-0.5 shrink-0" />
            <p className="text-sm text-[#1F2A36]">
              Ingen år med kraftig fall i fonda eller arbeidskapitalen i perioden {data.first_year}–{data.last_year}.
            </p>
          </div>
        ) : (
          alerts.map((a) => {
            const tone = TONE[a.severity] || TONE.moderat;
            return (
              <div
                key={`${a.key}-${a.year}`}
                className={`flex items-start gap-3 p-4 border rounded-lg ${tone.border} ${tone.bg}`}
                data-testid={`varsel-${a.key}-${a.year}`}
              >
                <TrendingDown className={`w-5 h-5 mt-0.5 shrink-0 ${tone.text}`} />
                <div className="space-y-1">
                  <p className="text-sm font-medium text-[#1F2A36]">
                    <span className={`text-xs font-semibold uppercase tracking-[0.08em] mr-2 ${tone.text}`}>{a.year} · {tone.badge}</span>
                    {a.label} fall {dec(Math.abs(a.change_pct), 1)} % frå {a.prev_year} til {a.year}
                  </p>
                  <p className="text-sm text-[#4B647F]">
                    Frå {mill(a.from)} til {mill(a.to)}
                    {a.change_pp != null && (
                      <>
                        {" "}– ein nedgang på {dec(Math.abs(a.change_pp), 1)} prosentpoeng av driftsinntektene ({dec(a.prev_pct, 1)} % → {dec(a.pct, 1)} %)
                      </>
                    )}
                    .
                  </p>
                  <p className="text-xs text-[#4B647F]">{a.forklaring}</p>
                </div>
              </div>
            );
          })
        )}
        <p className="text-xs text-[#8AA4BF]">{data.terskel} Tala er henta frå KOSTRA-balansen (SSB 13545) og brutto driftsinntekter.</p>
      </CardContent>
    </Card>
  );
};

export default VarselSection;
